document.addEventListener('DOMContentLoaded', function () {
  function formatDateTime(dateTime) {
    let data = dateTime.split(' - ');
    let date = data[0].split('-');
    let time = data[1];
    let year = date[2];
    let month = date[1];
    let day = date[0];
    return year + '-' + month + '-' + day + ' ' + time;
  }

  const countdownBar = document.querySelector('.qlf-countdown-hero-bar');
  if (countdownBar) {
    let countDownEndDate = new Date(
      formatDateTime(countdownBar.getAttribute('data-cdb-end'))
    ).getTime();

    let x = setInterval(function () {
      let now = new Date().getTime();

      // Find the distance between now and the count down date
      let distance = countDownEndDate - now;

      // If the count down is finished, hide the countdown bar
      if (distance < 0) {
        clearInterval(x);
        countdownBar.style.display = 'none';
        return;
      }

      // Time calculations for days, hours, minutes and seconds
      let days = Math.floor(distance / (1000 * 60 * 60 * 24)).toLocaleString('en-US', {
        minimumIntegerDigits: 2,
        useGrouping: false
      });
      let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)).toLocaleString(
        'en-US',
        {
          minimumIntegerDigits: 2,
          useGrouping: false
        }
      );
      let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)).toLocaleString(
        'en-US',
        {
          minimumIntegerDigits: 2,
          useGrouping: false
        }
      );
      let seconds = Math.floor((distance % (1000 * 60)) / 1000).toLocaleString('en-US', {
        minimumIntegerDigits: 2,
        useGrouping: false
      });

      // Display the result in the elements, with null checks
      const daysElement = document.querySelector('.qlf-cdb-days');
      const hoursElement = document.querySelector('.qlf-cdb-hours');
      const minutesElement = document.querySelector('.qlf-cdb-minutes');
      const secondsElement = document.querySelector('.qlf-cdb-seconds');
      const daysLabelElement = document.querySelector('.qlf-cdb-days-label');
      const hoursLabelElement = document.querySelector('.qlf-cdb-hours-label');
      const minutesLabelElement = document.querySelector('.qlf-cdb-minutes-label');
      const secondsLabelElement = document.querySelector('.qlf-cdb-seconds-label');

      // Update time values with null checks
      if (daysElement) daysElement.innerHTML = days;
      if (hoursElement) hoursElement.innerHTML = hours;
      if (minutesElement) minutesElement.innerHTML = minutes;
      if (secondsElement) secondsElement.innerHTML = seconds;

      // Update labels with null checks
      if (daysLabelElement) {
        if (days === '01') {
          daysLabelElement.innerHTML = 'Tag';
        } else {
          daysLabelElement.innerHTML = 'Tage';
        }
      }

      if (hoursLabelElement) {
        hoursLabelElement.innerHTML = 'Std.';
      }

      if (minutesLabelElement) {
        minutesLabelElement.innerHTML = 'Min.';
      }

      if (secondsLabelElement) {
        secondsLabelElement.innerHTML = 'Sek.';
      }
    }, 1000);
  }
});
